import axios from "axios";
const BaseURL = process.env.REACT_APP_API_PATH;

export const getGraduationList = async (type) => {
    try {
        const res = await axios.get(`${BaseURL}/degree/get_all_degree?category=${type}`);
        return res
    } catch (error) {
        console.log("errror of cities api")
        return error | "Internal Server Error"
    }
};

export const getBoardsList = async () => {
    try {
        const res = await axios.get(`${BaseURL}/boards/get_all_boards`);
        return res
    } catch (error) {
        console.log("errror of cities api")
        return error | "Internal Server Error"
    }
};